import styled from 'styled-components';

const MapWrapper = styled.div`
  position: relative;

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    width: 100%;
    height: 100%;
  }

  @media only screen and (min-width: ${({ theme }) =>
      theme.BP.VDP_DESKTOP_WL}) {
    width: 1046px;
    height: 478px;
    margin: 24px;
  }
`;

export default MapWrapper;
